module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAkBAMAAAAX21WWAAAAAXNSR0IArs4c6QAAAB5QTFRFAAAA////pKSkmZmZn5+fpaWll5eXmJiYmJiYl5eXthIBfQAAAAl0Uk5TAAEODxAR4O/wW1s4UAAAADlJREFUKM9jYO6AgwQGKGCdCQcFcLEZLjCgABebzoABaCI2EwXgEUPWOXzEGJ0wxZCpkSOGGudYxAAp5Vinxa5JWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/copy-icon.png
// module id = 66Qz
// module chunks = 241